import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import { Wrapper } from "@cinch-nx/shared-ui";
import TrustpilotLogo from "./assets/trustpilot-logo.svg";
import TrustpilotStars from "./stars/stars";
import styles from "./trustpilot-overview.module.css";
var TRUSTPILOT_URL = "https://uk.trustpilot.com/review/cinch.co.uk";
export function TrustpilotOverview(param) {
    var starRating = param.starRating, starRatingLabel = param.starRatingLabel;
    return /*#__PURE__*/ _jsx(Wrapper, {
        className: {
            container: styles["container"],
            inner: styles["inner"]
        },
        "data-testid": "trustpilot-overview-score",
        children: /*#__PURE__*/ _jsxs("a", {
            href: TRUSTPILOT_URL,
            target: "_blank",
            rel: "noreferrer",
            className: styles["link"],
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    className: styles["trustpilotScore"],
                    children: starRatingLabel
                }),
                /*#__PURE__*/ _jsx(TrustpilotStars, {
                    className: styles["trustpilotStars"],
                    starRating: starRating,
                    starRatingLabel: starRatingLabel
                }),
                /*#__PURE__*/ _jsx(TrustpilotLogo, {
                    className: styles["trustpilotLogo"]
                })
            ]
        })
    });
}
export default TrustpilotOverview;
